var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:_vm.className,attrs:{"data-error":_vm.invalid}},[_c('input',_vm._b({attrs:{"placeholder":" "},domProps:{"value":_vm.value},on:{"input":_vm.emitInput}},'input',_vm.$attrs,false)),_vm._v(" "),_c('span',{staticClass:"base-field__text-label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }